/**
 * Minimal fix for search modal scrolling
 * Only prevents body scrolling when search is open
 */
(function() {
  // Function to handle search modal state
  function setupSearchScrollLock() {
    // Use document-level event delegation for robustness
    document.addEventListener('click', function(event) {
      // Check if the clicked element is the search button or inside the search modal
      const searchButton = event.target.closest('.header__icon--search');
      const closeButton = event.target.closest('.search-modal__close-button');
      
      if (searchButton) {
        // Search was clicked - check if it's opening or closing
        setTimeout(function() {
          const isOpen = document.querySelector('.header__search details[open]');
          if (isOpen) {
            // Modal is opening - prevent scrolling
            document.body.style.overflow = 'hidden';
          } else {
            // Modal is closing - restore scrolling
            document.body.style.overflow = '';
          }
        }, 10); // Small delay to let the details element update
      } else if (closeButton) {
        // Close button clicked - restore scrolling
        document.body.style.overflow = '';
      }
    });
    
    // Also handle escape key
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        const searchModal = document.querySelector('.header__search details[open]');
        if (searchModal) {
          // Search modal is open and Escape was pressed
          document.body.style.overflow = '';
        }
      }
    });
    
    // Add a MutationObserver to watch for changes to the details element
    // This ensures we catch all possible ways the search modal can be opened or closed
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          const details = mutation.target;
          if (details.hasAttribute('open')) {
            // Modal is open - prevent scrolling
            document.body.style.overflow = 'hidden';
          } else {
            // Modal is closed - restore scrolling
            document.body.style.overflow = '';
          }
        }
      });
    });
    
    // Start observing once the search modal is available
    function startObserving() {
      const searchDetails = document.querySelector('.header__search details');
      if (searchDetails) {
        observer.observe(searchDetails, { attributes: true });
      } else {
        // If not found, try again in a moment
        setTimeout(startObserving, 100);
      }
    }
    
    startObserving();
  }
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupSearchScrollLock);
  } else {
    setupSearchScrollLock();
  }
})();
